/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-23 12:01:29
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-05-22 14:04:40
 */
import { useCallback } from 'react'
import { capturePromiseException } from '../../../../utils/sentryUtils'

// 照片数据项类型（原生对象）
interface PhotoItem {
  mediaType: number
  largeURL: string
  videoURL: string
  userID: string
  [key: string]: any
}

export function usePhotoData({ state, setState, currentVisible, props }) {
  // 获取水印信息
  const handleFetchWatermark = useCallback(
    (index: number, photos: PhotoItem[] = props.photos) => {
      const { groupId, userId } = props
      const photo = photos[index]
      if (photo) {
        const mediaURL = photo.mediaType === 0 ? photo.largeURL : photo.videoURL
        props
          .fetchWatermarkByUrl({
            groupID: groupId,
            userID: userId,
            mediaType: photo.mediaType,
            mediaURL: mediaURL.split('?')[0]
          })
          .then((data) =>
            setState((prevState) => ({
              ...prevState,
              watermarks: data.payload.watermarks,
              watermarkLoading: false,
              authorUserId: data.payload.userID
            }))
          )
          .then(() => {
            if (props.visible && !currentVisible.current) {
              // 关闭后重新打开
              const photoFrame =
                document.getElementsByClassName('photo-frame')[
                  state.activeIndex + 1
                ]
              if (photoFrame) {
                photoFrame.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center'
                })
              }
            }
            currentVisible.current = props.visible || false
          })
          .catch((err) => {
            setState((prevState) => ({
              ...prevState,
              watermarkLoading: false,
              watermarks: []
            }))
            capturePromiseException(err)
          })
      }
      setState((prevState) => ({ ...prevState, watermarkLoading: false }))
    },
    [props, state.activeIndex, setState, currentVisible]
  )

  // 获取文件夹信息
  const handleFetchFolderInfo = useCallback(
    (index: number, photos: PhotoItem[] = props.photos) => {
      if (props.isHideFoldersInfo) {
        return
      }

      const { groupId, myRole, viewPerm, userId } = props
      const photo = photos[index]

      if (photo && !props.isHideWatermarkInfo) {
        const isShowAddToFolderBtn =
          myRole === 1 || // CONFIG.memberRoleTypes.MASTER_ADMIN
          myRole === 2 || // CONFIG.memberRoleTypes.ADMIN
          myRole === 3 || // CONFIG.memberRoleTypes.DEPARTMENT_ADMIN
          (viewPerm === 0 && photo.userID === userId)

        props
          .fetchPhotoInfo({
            groupID: groupId,
            photo
          })
          .then((res) => {
            setState((prevState) => ({
              ...prevState,
              folders: res.folders,
              isShowAddToFolderBtn
            }))
          })
      }
    },
    [props, setState]
  )

  return {
    handleFetchWatermark,
    handleFetchFolderInfo
  }
}
